<script setup lang="ts">
defineProps<{
  long?: boolean;
}>();
</script>

<template>
  <ul class="list" :class="[$attrs['class'], { 'list--long': long }]">
    <slot />
  </ul>
</template>

<style scoped lang="scss">
@import "../../ArtworkQualityConfigPanel.scss";

.list {
  display: flex;
  flex-direction: column;
  gap: 13px;

  &--long {
    @include with-quality-container {
      width: 100%;
      display: grid;
      grid-template-columns: repeat(2, 1fr);
      grid-auto-flow: column;
      grid-template-rows: repeat(3, auto);
    }
  }
}
</style>
